import './style.css';
import Cover from '../../components/Cover';
import FlipSide from '../../components/FlipSide';
import TileComponent from '../../components/TileComponent';
import ScrollBackground from '../../components/ScrollBackground';



function Home () {

    return(
        <div className='home-screen'>
            <Cover/>    
            <TileComponent/>
            <FlipSide 
                title={'PRÄZISION'}
                imageUrl={'/img/Foto%206.JPG'} 
                description={'Entdecken Sie die Vorteile von Magic Tech Autopflege, Ihrem Experten für Autoaufbereitung und Fahrzeugpflege. Unser hochqualifiziertes Team legt Wert auf Präzision und Sorgfalt, um Ihr Auto perfekt zu reinigen und zu schützen. Mit hochwertigen Produkten und innovativen Techniken sorgen wir dafür, dass Ihr Fahrzeug in neuem Glanz erstrahlt.Egal, ob es um Lackaufbereitung, Innenreinigung oder Versiegelung geht – wir bieten maßgeschneiderte Lösungen für jedes Auto. Vertrauen Sie auf Magic Tech Autopflege für die beste Pflege Ihres Fahrzeugs. Buchen Sie jetzt einen Termin bei Magic Tech Autopflege in Ternitz, der exklusivsten Autokosmetik der Region und erleben Sie, warum wir die führende Wahl in Ternitz und Umgebung sind!'}
                backgroundColor={'#212429'}
                color={'white'}
            /> 
            <FlipSide 
                title={'ELEGANZ'} 
                imageUrl={'/img/Foto%207.JPG'} 
                description={'Ein sauberes Auto ist nicht nur ein Zeichen von Eleganz und Stil, sondern vermittelt auch Professionalität und Sorgfalt. Bei Magic Tech Autopflege legen wir Wert auf Perfektion. Mit präziser Lackaufbereitung, umfassender Lederpflege und gründlicher Innenraumreinigung bringen wir Ihr Fahrzeug in Bestform. Unsere Dienstleistungen bei Magic Tech garantieren langfristigen Schutz und makellosen Glanz. Ein gepflegtes Auto hinterlässt einen bleibenden Eindruck – ob auf der Straße oder beim Geschäftstreffen. Buchen Sie jetzt einen Termin bei Magic Tech Autopflege in Ternitz, der exklusivsten Autokosmetik der Region und erleben Sie, wie Ihr Fahrzeug wieder an Eleganz und Wert gewinnt!'}
                backgroundColor={'#212429'}
                color={'white'}
                reverse={true} 
            />
            <FlipSide 
                title={'Reperatur und Service'} 
                imageUrl={'/img/Foto%208.JPG'} 
                description={
                    <>
                        Gut gepflegte Fahrzeuge stehen für Sicherheit, Zuverlässigkeit und Werterhalt. Bei
                        Magic Tech Autopflege bieten wir Ihnen nicht nur professionelle Fahrzeugpflege,
                        sondern auch erstklassige Reparaturen, Ölwechsel, Reifenwechsel und
                        umfassenden Service rund um Ihr Auto. Unser erfahrenes Team arbeitet mit
                        modernster Technik und hochwertigen Produkten, damit Ihr Fahrzeug jederzeit in
                        bestem Zustand bleibt.
                        Ob regelmäßiger Ölwechsel, schneller Reifenservice oder fachgerechte Reparaturen
                        – wir sorgen dafür, dass Ihr Auto zuverlässig und leistungsstark bleibt. Bei Magic
                        Tech in Ternitz stehen Qualität, Präzision und Kundenzufriedenheit an erster Stelle. Vertrauen Sie auf unsere Expertise für die beste Pflege Ihres Fahrzeugs!{' '}
                        <strong>
                            Vertrauen Sie auf unsere Expertise und gönnen Sie Ihrem Fahrzeug den Service, den es verdient. Vereinbaren Sie jetzt Ihren Termin bei Magic Tech Autopflege und erleben Sie professionellen Rundum-Service für Ihr Auto. Ihr Fahrzeug wird es Ihnen danken!
                        </strong>
                    </>
                }
                backgroundColor={'#212429'}
                color={'white'}
            /> 
            
        </div>
    );

};

export default Home;